import { useEffect, useState, useRef } from 'react'
import { QUESTION_SUBMIT, INTERVIEW_SUBMIT } from '../../Utils/apis';

const useRecordInterview = (paramsObj) => {
    const { applicantId, jobId, questionNumber, onSucess, onInterviewEnd } = paramsObj;




    // these two state for window / tab switch  detection
    const windowVisibilityList = useRef([]);
    const interviewStartedTime = useRef(0);
    const morphcastStopRef = useRef(null);





    const [isUploading, setIsUploading] = useState(false);
    const recorder = useRef();
    let { current: chunck } = useRef([]);

    let { current: stream } = useRef(null);
    let { current: audio } = useRef(null);

    const submitTypeRef = useRef('ANSWER');

    const emotion = useRef([]);
    const formatedEmotionData = useRef({
        "Angry": 0,
        "Disgust": 0,
        "Fear": 0,
        "Happy": 0,
        "Neutral": 0,
        "Sad": 0,
        "Surprise": 0,
        "Attention": 0,
    });

    const interviewStop = async () => {
        if (morphcastStopRef.current) await morphcastStopRef.current();
        recorder.current?.stop();
    };

    // const stopMediaStreams = () => {
    //     stream?.getTracks().forEach(track => track.stop());
    //     audio?.getTracks().forEach(track => track.stop());
    //     stream = null;
    //     audio = null;
    //     recorder.current = null;
    // };

    const onStop = async () => {
        setIsUploading(true);
        const blob = new Blob(chunck, { type: 'video/webm' });
        const formData = new FormData();

        chunck = [];

        formData.append('video', blob);
        formData.append('emotionData', JSON.stringify(formatedEmotionData.current));
        formData.append('applicantId', applicantId);
        formData.append('question_no', questionNumber);
        formData.append('jobId' , jobId);

        windowVisibilityList?.current?.forEach((item) => {
            formData.append('tabSwitchTiming', JSON.stringify(item));
        });


        try {
            if (submitTypeRef.current === 'END') {
                const res = await fetch(QUESTION_SUBMIT, { method: 'POST', body: formData, credentials: 'include' });
                if (res.ok) {
                    const json = await res.json();
                    if (json.status === 'SUCCESS') {
                        await fetch(INTERVIEW_SUBMIT, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ applicantId: applicantId , jobId: jobId }),
                            credentials: 'include',
                        });
                        onInterviewEnd();
                    }
                }
            } else {
                const res = await fetch(QUESTION_SUBMIT, { method: 'POST', body: formData, credentials: 'include' });
                if (res.ok) onSucess();
            }
        } catch (err) {
            // console.error('Error uploading chunk:', err);
        } finally {
            setIsUploading(false);
        }

        stream.getTracks().forEach((track) => track.stop());
        audio.getTracks().forEach((track) => track.stop());
        // stopMediaStreams();
    };

    const mphListener = (evt) => {
        // Log emotion data
        const dominantEmotion = evt.detail?.face_emotion?.dominantEmotion;
        if (dominantEmotion in formatedEmotionData.current) {
            formatedEmotionData.current[dominantEmotion] = formatedEmotionData?.current?.[dominantEmotion] + 1;
        }
        // console.log(formatedEmotionData);

        // Log attention data
        const attentionScore = evt.detail?.face_attention?.attention;
        if (attentionScore !== undefined) {
            // Increment attention counter when attention is above threshold (e.g., 0.6)
            if (attentionScore > 0.6) {
                formatedEmotionData.current["Attention"] = formatedEmotionData.current["Attention"] + 1;
            }
        }
        // console.log(formatedEmotionData)

        const lowAttention = evt.detail?.alarm_low_attention?.alarm;
        if (lowAttention !== undefined) {

        }

    }

    const endInterview = () => {
        submitTypeRef.current = 'END';
        interviewStop();
    };

    useEffect(() => {
        let mixedStream;

        (
            async () => {
                try {
                    stream = await navigator.mediaDevices.getUserMedia({
                        video: {
                            width: { ideal: 360 },
                            height: { ideal: 180 },
                        }
                    });
                    audio = await navigator.mediaDevices.getUserMedia({
                        audio: {
                            echoCancellation: true,
                            noiseSuppression: true,
                            sampleRate: 44100,
                        },
                    });
                }
                catch (err) {
                    alert("Please grant permission for the camera and microphone.");
                }


                if (stream && audio) {
                    mixedStream = new MediaStream([...stream.getTracks(), ...audio.getTracks()]);
                    recorder.current = new MediaRecorder(mixedStream);

                    recorder.current.ondataavailable = (e) => chunck.push(e.data);
                    recorder.current.onstop = onStop;
                    recorder.current.start(1000);
                }
                else {
                    console.warn('No stream available.');
                }
            }
        )();

        // MorphCast setup
        const MorphCastStatistics = window.MorphCastStatistics;

        const CY = window.CY;
        const MphTools = window.MphTools;
        const statsConfig = {
            sendDatainterval: 5000,
            tickInterval: 1000,
            stopAfter: 100000,
            licenseKey: "sk297555721a317f909b651b1a569d1674904b8e5001e9"
        };
        const statisticsUploader = new MorphCastStatistics.StatisticsUploader(statsConfig);

        CY.loader()
            .licenseKey("sk297555721a317f909b651b1a569d1674904b8e5001e9")
            .addModule(CY.modules().FACE_EMOTION.name, { smoothness: 0.40 })
            .addModule(CY.modules().FACE_ATTENTION.name, { smoothness: 0.83 })
            .addModule(CY.modules().ALARM_LOW_ATTENTION.name, { timeWindowMs: 5000, initialToleranceMs: 7000, threshold: 0.33 })
            .addModule(CY.modules().FACE_DETECTOR.name, { maxInputFrameSize: 320, smoothness: 0.83 })
            .addModule(CY.modules().ALARM_MORE_FACES.name, { timeWindowMs: 3000, initialToleranceMs: 7000, threshold: 0.33 })
            .addModule(CY.modules().ALARM_NO_FACE.name, { timeWindowMs: 10000, initialToleranceMs: 7000, threshold: 0.75 })
            .load()
            .then(async ({ start, stop }) => {
                await start();
                await statisticsUploader.start();

                morphcastStopRef.current = async () => {
                    await statisticsUploader.stop();
                    await stop();
                };
            }).catch(er => {
                // console.log(er)
            }
            );

        const { eventName } = CY.modules().EVENT_BARRIER;
        window.addEventListener(eventName, mphListener);

        MphTools.CameraPrivacyPopup.setText({
            "title": "Allow us to use your camera",
            "description": "This experience is designed to be viewed with your camera on. The next screen will ask your consent to access data from your camera.",
            "url": "https://YOUR_DOMAIN/<YOUR_PRIVACY_POLICY>"
        });

        return () => {
            if (morphcastStopRef.current) morphcastStopRef.current();
            window.removeEventListener(eventName, mphListener);
            mixedStream?.getTracks().forEach(track => track.stop());
            // recorder.current = null;
            // stream.current = null;
            // audio.current = null;
        }
    }, []);


    // for window / tab switch  detection

    useEffect(() => {

        const id = setInterval(() => { interviewStartedTime.current += 1; }, 1000);

        const onVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                windowVisibilityList?.current?.push([interviewStartedTime.current]);
            } else {
                const lastIndex = windowVisibilityList?.current?.length - 1;

                windowVisibilityList?.current?.[lastIndex]?.push(interviewStartedTime.current)
            }

            // console.log(windowVisibilityList);
        }
        window.addEventListener('visibilitychange', onVisibilityChange)

        return () => { clearInterval(id); window.removeEventListener('visibilitychange', onVisibilityChange); }
    }, []);


    return [interviewStop, endInterview, isUploading]
}
export default useRecordInterview;